import { Select } from 'antd';
import { cn } from '@/lib/utils';

export interface MultiSelectOption {
  label: string;
  value: string;
}

export interface MultiSelectProps {
  options: MultiSelectOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
  placeholder?: string;
  className?: string;
  maxDisplay?: number; // 最多显示的标签数量（Ant Design 原生支持，此参数保留但不使用）
}

export function MultiSelect({
  options,
  selected,
  onChange,
  placeholder = '请选择...',
  className,
}: MultiSelectProps) {
  // 提取宽度类，Ant Design Select 需要通过 style 设置宽度
  const widthMatch = className?.match(/w-\[(\d+)px\]/);
  const isFullWidth = className?.includes('w-full');
  const width = isFullWidth ? '100%' : widthMatch ? `${widthMatch[1]}px` : '280px';

  return (
    <Select
      mode="multiple"
      value={selected}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      className={cn(className)}
      style={{ width, minWidth: isFullWidth ? undefined : width }}
      maxTagCount="responsive"
      allowClear
      dropdownStyle={{ minWidth: widthMatch ? width : '280px' }}
      popupMatchSelectWidth={false}
    />
  );
}
